interface Data {
  [key: string]: any;
}

interface Annotations {
  "appmgr.object.description": string;
  "appmgr.object.createBy": string;
}
interface Path {
  path: string;
  backend: {
    serviceName: string;
    servicePort: string | number;
  };
}
interface Rules {
  host?: string;
  http: { paths: Array<Path> };
}
interface Metadata {
  namespace: string;
  labels: { app: string };
  name: string;
  annotations: Annotations;
}
interface TLS {
  hosts: Array<string>;
  secretName: string;
}
interface Spec {
  tls: Array<TLS> | null;
  rules: Array<Rules>;
}
interface CreateIngressData {
  apiVersion: string;
  kind: string;
  metadata: Metadata;
  spec: Spec;
  protocolType: string;
}
export const CreateIngressForm: CreateIngressData = {
  kind: "Ingress", // 固定
  apiVersion: "extensions/v1beta1", // 固定
  metadata: {
    name: "", // 路由名称
    namespace: "",
    labels: {
      app: ""
    },
    annotations: {
      "appmgr.object.description": "", // 路由描述
      "appmgr.object.createBy": "" // 创建人
    }
  },
  spec: {
    // https 才有
    tls: [
      {
        hosts: [],
        secretName: ""
      }
    ],
    rules: [
      {
        host: "", // 域名
        http: {
          paths: [
            {
              path: "/",
              backend: {
                serviceName: "",
                servicePort: ""
              }
            }
          ]
        }
      }
    ]
  },
  protocolType: "http" // 协议类型
};
